// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/collection-driver/collection-driver';
import 'snippets/collection-filters-sort/collection-filters-sort';

import 'sections/page-header/page-header';
import 'sections/footer/footer';
import 'sections/order-sheet/order-sheet';


// Styles
import './_collection.scss';
